module.exports = __webpack_public_path__ + "img/luli.16be96f7.jpg";